// extracted by mini-css-extract-plugin
module.exports = {"container":"PurpleBox_container__3b6_q","mobile":"PurpleBox_mobile__2_OGw","label":"PurpleBox_label__1UGIM","text":"PurpleBox_text__14ghm","compact":"PurpleBox_compact__1U3-P"};